<template>
  <section class="section container pt-0">
    <drives-datatable />
  </section>
</template>

<script>
import DrivesDatatable from "./drives_datatable/Index.vue";

export default {
  name: "DriveIndex",
  components: { DrivesDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
